import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { SVGMap } from "react-svg-map";
import india from "@svg-maps/india";
import "react-svg-map/lib/index.css";
import { motion } from "framer-motion";

const regionData = {
    Karnataka: 1212,
    Telangana: 1467,
    Maharashtra: 927,
    "Tamil Nadu": 863,
    Delhi: 929,
    "Uttar Pradesh": 499,
    Rajasthan: 221,
    Kerala: 253,
    Bihar: 252,
    Odisha: 352,
};

const topStates = Object.entries(regionData)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 3)
    .map(([name]) => name);

const getColor = (value) => {
    if (!value) return "#f8fafc";
    if (value > 1200) return "#1e3a8a";
    if (value > 800) return "#2563eb";
    if (value > 400) return "#3b82f6";
    if (value > 100) return "#60a5fa";
    return "#bfdbfe";
};

export default function IndiaInsaneMap() {
    const [activePulse, setActivePulse] = useState(0);
    const [tooltip, setTooltip] = useState({
        visible: false,
        x: 0,
        y: 0,
        name: "",
        value: 0,
    });

    // pulse animation
    useEffect(() => {
        const interval = setInterval(() => {
            setActivePulse((prev) => (prev + 1) % topStates.length);
        }, 1500);
        return () => clearInterval(interval);
    }, []);

    return (
        <Box
            sx={{
                fontFamily: "Poppins",
                px: { xs: 2, md: 6 },
                py: 6,
                background:
                    "radial-gradient(circle at top, #eef5ff, #ffffff)",
            }}
        >
            {/* <Typography
                sx={{
                    fontSize: { xs: "24px", md: "34px" },
                    fontWeight: 600,
                    textAlign: "center",
                    mb: 4,
                }}
            >
                Live Learner Footprint
            </Typography> */}

            <Box
                sx={{ position: "relative", display: "flex", justifyContent: "center" }}
                onMouseMove={(e) => {
                    const target = e.target;

                    if (target.tagName === "path") {
                        const name = target.getAttribute("name");
                        const value = regionData[name] || 0;

                        setTooltip({
                            visible: true,
                            x: e.clientX,
                            y: e.clientY,
                            name,
                            value,
                        });
                    } else {
                        setTooltip((prev) => ({ ...prev, visible: false }));
                    }
                }}
            >
                <motion.div style={{ width: "70%", maxWidth: 650 }}>
                    <SVGMap
                        map={india}
                        style={{ width: "100%", height: "auto" }}
                        locationProps={(loc) => ({
                            fill: getColor(regionData[loc.name]),
                            style: { cursor: "pointer" },
                        })}
                    />
                </motion.div>

                {/* TOOLTIP */}
                {tooltip.visible && (
                    <Box
                        sx={{
                            position: "fixed",
                            top: tooltip.y,
                            left: tooltip.x,
                            transform: "translate(12px, 12px)",
                            pointerEvents: "none",
                            zIndex: 9999,
                            backdropFilter: "blur(12px)",
                            background: "rgba(17, 24, 39, 0.9)",
                            color: "#fff",
                            borderRadius: "12px",
                            px: 2,
                            py: 1.5,
                            boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
                            minWidth: "150px",
                        }}
                    >
                        <Typography fontSize="13px" opacity={0.7}>
                            {tooltip.name}
                        </Typography>

                        <Typography
                            sx={{
                                fontSize: "15px",
                                fontWeight: 700,
                                color: "#60a5fa",
                            }}
                        >
                            {tooltip.value} learners
                        </Typography>

                    
                    </Box>
                )}
            </Box>

            {/* Hover styles */}
            <style>
                {`
          .svg-map path {
            stroke: #fff;
            stroke-width: 1;
          }

          .svg-map path:hover {
            stroke: #1d4ed8;
            stroke-width: 2;
            filter: brightness(1.1);
          }
        `}
            </style>
        </Box>
    );
}